import { cn } from '@/utils/style'
import React from 'react'

const SvgLoadingSpin: React.FC<{
  color?: 'accent' | 'white' | 'dark' | 'red'
  className?: string
}> = ({ color = 'white', className }) => {
  return (
    <svg
      className={cn('animate-spin h-5 w-5', className, {
        'text-white': color === 'white',
        'text-accent': color === 'accent',
        'text-grat-700': color === 'dark',
        'text-red-700': color === 'red',
      })}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      data-darkreader-inline-fill=""
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        data-darkreader-inline-stroke=""
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        data-darkreader-inline-fill=""
      />
    </svg>
  )
}

export default SvgLoadingSpin
